export default __webpack_public_path__ + "static/media/office-3.dccc7176.mp4";